<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense>
                <v-col cols="12">
                    <ModalInformacionComponent :titulo="obModal.titulo" :open="obModal.open" :descripcion="obModal.descripcion"/>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-row dense align="center" justify="center">
                        <v-col cols="12" sm="10">
                            <div class="text-center">
                                <h1 :class="$root.isTouch ? 'titleSection title' : 'titleSection'">Servicios Incluidos</h1>
                            </div>
                            <div :class="$root.isTouch ? 'mt-3' : 'text-center mt-3'">
                                <p class="contenido" :style="$root.isTouch ? 'text-align:justify' : ''">
                                    Esto son todos los beneficios que incluimos para hacerte la vida más sencilla,
                                    segura y feliz. Sientete libre de quitar o agregar lo que consideres más útiles o
                                    convenientes.
                                </p>
                            </div>
                        </v-col>
                    </v-row>

                    <v-row dense v-if="!$root.isTouch">
                        <v-col cols="12" sm="12" class="wrapper">
                            <v-row dense align="center" justify="center" class="scroll">
                                <v-col cols="12" sm="11" md="10">
                                    <v-row dense v-for="(v,k) in _.orderBy(listBeneficioComplementario,['beneficio_comp'],['asc'])" :key="k" class="mb-1">
                                        <v-col cols="12" sm="12" class="wrapServIncl">
                                            <v-row dense>
                                                <v-col cols="12" sm="2">
                                                    <div class="center">
                                                        <v-img :src="v.base64" contain height="60" max-height="60"></v-img>
                                                    </div>
                                                </v-col>
                                                <v-col cols="12" sm="7">
                                                    <h5 class="titleGastCub text-left" v-html="v.beneficio_comp" />
                                                    <p class="mt-2 contenidoServIncl" v-html="v.definicion_corta" />
                                                    <div class="text-left">
                                                        <a class="linkRedSerInc" id="infoBene" @click="verDetalle(v)" v-html="'Ver Detalles'" />
                                                    </div>
                                                </v-col>
                                                <v-col cols="12" sm="3">
                                                    <v-row dense>
                                                        <v-col cols="12" sm="6">
                                                            <p class="ServIncl mt-10 text-center" v-html="v.mensaje"/>
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-radio-group v-model="v.active" :mandatory="false" row>
                                                                <v-radio :value="true" class="mt-5" dense color="primary" @click="mapList(v)"></v-radio>
                                                            </v-radio-group>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>                            
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row v-else dense v-for="(v,k) in _.orderBy(listBeneficioComplementario,['beneficio_comp'],['asc'])" :key="k" class="mb-1">
                        <v-col cols="12" sm="12" class="wrapServIncll">
                            <v-row dense>
                                <v-col cols="12" class="text-center">
                                    <v-tooltip top dark>
                                        <template v-slot:activator="{ on }">
                                            <v-img :src="v.base64" contain height="40" max-height="40" v-on="on"></v-img>
                                        </template>
                                        <p class="contenidoServIncl body-2 white--text" v-html="v.definicion_corta" />
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" class="text-center">
                                    <h5 class="titleGastCub" v-html="v.beneficio_comp" />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" class="text-center">
                                    <v-btn text class="overline" color="primary" small v-html="'Ver Detalles'" @click="verDetalle(v)"></v-btn>
                                        <!-- <p class="contenidoServIncl body-2 white--text" v-html="v.definicion_tecnica_cis" /> -->
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" style="margin-top:-20px">
                                    <v-radio-group v-model="v.active" :mandatory="false" row>
                                        <v-radio :value="true" class="ml-5" :label="v.mensaje" dense color="primary" @click="mapList(v)"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>       

                    <v-row dense class="mt-3 mb-3" align="center" justify="center">
                        <v-col cols="12" class="text-center">
                            <v-icon color="secundary" class="btnNext" @click="siguiente">arrow_forward</v-icon>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
 
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowBeneficioComplemetarioComponent',
        inject: ['next', 'updateData','recalcularPrima'],
        components:{
            ModalInformacionComponent: () => import('@/components/ajustePoliza/renovacion/vehiculo/ModalInformacionComponent.vue')
        },
        props: {
            listBeneficioComplementarioActual: {
                type: Array,
                default: () => []
            },
            listBeneficioComplementarioNueva: {
                type: Array,
                default: () => []
            },
            stepper: {
                type: Number
            },
            parametros:{
                type:Object,
                default:{}
            }
        },
        data: () => ({
            listBeneficioComplementario: [],
            obModal:{
                titulo:'',
                open:false,
                descripcion:''
            }
        }),
        created() {
            this.$set(this, 'listBeneficioComplementario',_.cloneDeep(this.listBeneficioComplementarioNueva));
        },
        watch: {
            stepper(val) {
                if (val == 3) {
                    this.$set(this, 'listBeneficioComplementario',_.cloneDeep(this.listBeneficioComplementarioNueva));
                }
            }
        },
        methods: {
            mapList(o){
                new Promise((resolve,reject)=>{
                    var index = _.findIndex(this.listBeneficioComplementario,{'index':o.index});
                    this.listBeneficioComplementario[index].active = !o.active;
                    this.updateData('objForm.objInfoSeguroRenovacion.servicios_incluidos',this.listBeneficioComplementario);

                    return resolve(true);
                })
                .then((r)=>{
                    if(!r) throw 'Error';
                        this.recalcularPrima(false);
                })
                .catch((e)=>{
                    mensajesAlerta(e,'E');
                });
            },
            siguiente() {
                this.updateData('objForm.objInfoSeguroRenovacion.servicios_incluidos',this.listBeneficioComplementario);
                this.next();
            },
            verDetalle(objeto){
                this.obModal = {
                    titulo: objeto.beneficio_comp,
                    descripcion: objeto.definicion_tecnica_cis,
                    open: true
                };
            },
            close(){
                this.obModal = {
                    titulo:'',
                    open: false,
                    descripcion:''
                };
            }
        },
        provide(){
            return{
                close: this.close
            }
        }
    }
</script>

<style scoped>
    h5.titleGastCub {
        font-size: 1rem;
        letter-spacing: 2px;
        color: #898989;
        font-weight: 700;
        text-transform: none;
    }

    .contenidoServIncl {
        font-size: 0.85rem;
        color: #808080;
        font-weight: 300;
        text-transform: none;
        margin-bottom: 0.15rem;
        text-align: justify ;
    }

    .wrapServIncll {
        margin: 0 5px !important;
        background: #F4F4F4;
        padding: 20px;
        border-radius: 10px;
        min-height: 100px;
        margin-bottom: 5px !important;
    }

    .ServIncl {
        font-size: 0.85rem;
        color: #808080;
        font-weight: 600;
        text-transform: uppercase;
    }

    a.linkRedSerInc,
    a:hover.linkRedSerInc {
        color: #FF4132 !important;
        font-weight: 500;
        font-style: italic;
        text-decoration: none !important;
        font-size: 0.8rem;
        cursor: pointer;
    }

    .scroll {
        overflow-y: scroll;
    }

    .wrapper{
        height:400px !important;
    }

    #infoBene:hover {
        text-decoration: underline !important;
    }

    #infoBene:active {
        text-decoration: underline !important;
    }

</style>